import React from 'react';
import { Skeleton } from '@/UI';
import {
  CardLocalItemSkeletonContainer,
  DescriptionContainer,
  StyledSkeletonImage,
} from './CardLocalItemSkeleton.styles';

const CardLocalItemSkeleton = () => (
  <CardLocalItemSkeletonContainer>
    <StyledSkeletonImage />
    <DescriptionContainer>
      <Skeleton style={{ height: 21, width: '50%', marginBottom: 24 }} />
      <Skeleton style={{ height: 16, width: '100%', marginBottom: 4 }} />
    </DescriptionContainer>
  </CardLocalItemSkeletonContainer>
);

export default CardLocalItemSkeleton;
